<template>
    <section>
        <div class="page">
            <div>
                <h2>
                    Notifications are not working
                </h2>
                <p>
                    When a message is sent to you via ToTok,, but you do not have the app open to receive it, your
                    iPhone will
                    automatically display a push notification to alert you of the message. iOS apps can provide three
                    types of
                    notifications:
                </p>
                <ul>
                    <li>
                        Sounds: An audible alert plays.
                    </li>
                    <li>
                        Alerts/Banners: An alert or banner appears on the screen.
                    </li>
                    <li>
                        Badges: An image or number appears on the application icon.
                    </li>
                </ul>
                <h3>
                    Setting up notifications
                </h3>
                <p>
                    Please verify that your notification settings are turned on in both your ToTok and iPhone settings:
                </p>
                <ul>
                    <li>
                        Go to <strong>ToTok</strong> > <strong>Me</strong> > <strong>Notifications</strong> and check
                        that <strong><i>Notifications</i></strong>
                        are enabled for Messages, Groups, and Calls.
                    </li>
                    <li>
                        You can turn off the vibration or sounds you experience in the app, for example the sounds you
                        hear when you
                        send or receive messages. <strong>Go to ToTok</strong> > <strong>Me</strong> > <strong>Notifications</strong>
                        > <strong>In-App Notification</strong>.
                    </li>
                    <li>
                        Go to <strong>iPhone Settings</strong> > <strong>Notifications</strong> > <strong>ToTok</strong>.
                        Set your
                        preferences for Alert style (Banners, Pop-up alert, or None), Badges, and Sounds. If you want
                        notifications to
                        appear when your phone's display is off, enable Show on Lock Screen.
                    </li>
                    <ul>
                        <li>
                            The alert sound volume is controlled by your iPhone's ringer volume, which can be set in
                            <strong>iPhone
                                Settings</strong> > <strong>Sounds</strong>. Here, you can also set your
                            <strong>Vibrate</strong>
                            preferences.
                        </li>
                    </ul>
                </ul>
                <h3>Troubleshooting notification problems</h3>
                <p>If you have verified that your notification settings are correct in both iPhone settings and ToTok
                    settings and
                    you do not receive notifications, this is more than likely an issue with <a
                            href="https://totok.ai/faq/ios/20801">your connection</a>,
                    iOS or <a href="https://support.apple.com/HT203609">Apple's Push Notification Service</a>.</p>
                <p>Please note that delivery of notifications is controlled entirely by <strong>Apple's Push
                    Notification Service
                    (APNS)</strong>, and ToTok has no way to resolve issues with this service. If someone sends you a
                    message while
                    you are offline, that message will be sent to APNS to be delivered to your phone. ToTok has no
                    control or
                    visibility over the delivery of these notifications. The issue may be presenting itself in ToTok,
                    but the issue derives from APNS or
                    the iOS.
                </p>
                <p>Typically, the only way to resolve this issue is to <a
                        href="https://support.apple.com/en-us/HT201252">restore
                    the phone to factory settings</a> and set the phone up as new. If you restore a backup, you will
                    likely restore
                    the issue as well.</p>
                <p>Also note that push notifications require a valid SIM card and an active Wi-Fi or cellular
                    connection.
                </p>


            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
